import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { toast } from "sonner";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PageHeader, Stat } from "@/components/admin/common";
import { Field, SwitchRow } from "@/components/editor/fields";
import { QrDesigner } from "@/components/qr/QrStudio";
import { ClientSelect } from "@/pages/QrLinks";
import { api, formatErr } from "@/lib/api";

export default function QrLinkDetail() {
  const { id } = useParams();
  const [it, setIt] = useState(null);
  const [form, setForm] = useState(null);
  useEffect(() => {
    api.get(`/qr-links/${id}`).then((r) => { setIt(r.data); setForm(r.data); });
  }, [id]);
  if (!it) return <div className="eyebrow">Caricamento…</div>;
  const dynamic = it.mode === "dynamic";
  const save = async () => {
    try {
      const { data } = await api.put(`/qr-links/${id}`, { name: form.name, target_url: form.target_url, client_id: form.client_id || "", mode: it.mode, active: form.active });
      setIt(data);
      setForm(data);
      toast.success(dynamic ? "Salvato: il QR ora porta alla nuova destinazione" : "Salvato");
    } catch (e) {
      toast.error(formatErr(e));
    }
  };
  return (
    <div>
      <Link to="/admin/qr" className="mb-6 inline-flex items-center gap-1.5 text-sm text-zinc-500 hover:text-zinc-900"><ArrowLeft className="h-4 w-4" />QR da link</Link>
      <PageHeader eyebrow={dynamic ? "QR dinamico" : "QR diretto"} title={it.name} />
      <div className="mb-8 grid gap-6 lg:grid-cols-[1fr_320px]">
        <div className="panel space-y-4 p-6">
          <Field label="Nome interno" value={form.name} onChange={(v) => setForm({ ...form, name: v })} testId="qr-detail-name" />
          <Field label="Link di destinazione" value={form.target_url} onChange={(v) => setForm({ ...form, target_url: v })} testId="qr-detail-target"
            hint={dynamic ? "Puoi cambiarlo quando vuoi: i QR già stampati porteranno al nuovo link." : "QR diretto: se cambi il link devi riscaricare e ristampare il QR."} />
          <div><div className="text-xs text-zinc-600">Cliente</div><ClientSelect value={form.client_id} onChange={(v) => setForm({ ...form, client_id: v })} testId="qr-detail-client" /></div>
          {dynamic && <SwitchRow label="QR attivo" hint="Se disattivato, chi scansiona vede un messaggio di link non disponibile" checked={form.active} onChange={(v) => setForm({ ...form, active: v })} testId="qr-detail-active" />}
          <Button onClick={save} data-testid="qr-detail-save">Salva</Button>
        </div>
        {dynamic && <div className="grid gap-3"><Stat label="Scansioni totali" value={it.scans} testId="qr-detail-scans" /><Stat label="Ultimi 30 giorni" value={it.scans_30d} testId="qr-detail-scans-30" /></div>}
      </div>
      <QrDesigner
        initial={it.qr}
        getTarget={() => (dynamic ? it.short_url : it.target_url)}
        shareUrl={dynamic ? it.short_url : it.target_url}
        fileBase={`qr-${it.code}`}
        saveUrl={`/qr-links/${id}/qr`}
        note={dynamic ? "Il QR contiene un indirizzo breve di salvilo.it: puoi cambiare la destinazione senza ristamparlo." : "Il QR contiene direttamente il link di destinazione."}
      />
    </div>
  );
}
